import { configureStore, createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

interface PlayerState {
  isPlaying: boolean;
  isMuted: boolean;
  volume: number;
  duration: number;
  currentTime: number;
  buffered: number;
  isBuffering: boolean;
  isFullscreen: boolean;
  chapters: { start: number; title: string }[];
  heatmap: { time: number; intensity: number }[];
}

const initialState: PlayerState = {
  isPlaying: false,
  isMuted: false,
  volume: 1,
  duration: 0,
  currentTime: 0,
  buffered: 0,
  isBuffering: false,
  isFullscreen: false,
  chapters: [],
  heatmap: [],
};

const playerSlice = createSlice({
  name: 'player',
  initialState,
  reducers: {
    setPlaying: (state, action: PayloadAction<boolean>) => { state.isPlaying = action.payload; },
    setVolume: (state, action: PayloadAction<number>) => { state.volume = action.payload; },
    setDuration: (state, action: PayloadAction<number>) => { state.duration = action.payload; },
    setCurrentTime: (state, action: PayloadAction<number>) => { state.currentTime = action.payload; },
    setBuffering: (state, action: PayloadAction<boolean>) => { state.isBuffering = action.payload; },
    setFullscreen: (state, action: PayloadAction<boolean>) => { state.isFullscreen = action.payload; },
    setChapters: (state, action: PayloadAction<{ start: number; title: string }[]>) => { state.chapters = action.payload; },
    setHeatmap: (state, action: PayloadAction<{ time: number; intensity: number }[]>) => { state.heatmap = action.payload; },
  },
});

export const { setPlaying, setVolume, setDuration, setCurrentTime, setBuffering, setFullscreen, setChapters, setHeatmap } = playerSlice.actions;

export const store = configureStore({
  reducer: {
    player: playerSlice.reducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
